/* TR motion: count-up numbers, bar/ring fills, scroll reveal, sticky header shadow */
(function () {
  if (window.__trMotion) return;
  window.__trMotion = true;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);
  var hasIO = 'IntersectionObserver' in window;
  var root = document.documentElement;

  var COUNT_SEL = [
    '.tr-stats__item b', '.tr-power__stat b', '.tr-rv__big', '.tr-rv__sum > div:last-child b',
    '.tr-rv__bar span:last-child', '.tr-ship__bar i', '.tr-rep__ring span', '.tr-announce__count'
  ].join(',');
  var BAR_SEL = '.tr-ship__bar i, .tr-rv__bar u';
  var STAGGER_SEL = '.tr-bs__grid > *, .tr-wall > *, .tr-rf > *, .tr-feats > *, .tr-ev__list > *, .tr-com__grid > *, .tr-how__row > *, .tr-power__stats > *, .tr-rep__row, .tr-rv__item';

  function ease(t) { return 1 - Math.pow(1 - t, 3); }

  function parseNum(text) {
    var m = /(\d[\d,]*)(\.\d+)?/.exec(text);
    if (!m) return null;
    var dec = m[2] ? m[2].length - 1 : 0;
    var val = parseFloat(m[1].replace(/,/g, '') + (m[2] || ''));
    return { start: m.index, len: m[0].length, val: val, dec: dec, comma: m[1].indexOf(',') > -1 };
  }
  function fmt(n, p) {
    var s = n.toFixed(p.dec);
    if (p.comma) {
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      s = parts.join('.');
    }
    return s;
  }

  function animateCount(el) {
    if (el.dataset.trDone) return;
    el.dataset.trDone = '1';
    var orig = el.dataset.trOrig;
    var p = parseNum(orig);
    if (!p || p.val === 0 || reduce) { el.textContent = orig; return; }
    var pre = orig.slice(0, p.start), post = orig.slice(p.start + p.len);
    var t0 = null, dur = 1600;
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur);
      el.textContent = pre + fmt(p.val * ease(k), p) + post;
      if (k < 1) requestAnimationFrame(frame); else el.textContent = orig;
    }
    requestAnimationFrame(frame);
  }

  function animateRing(el) {
    if (el.dataset.trDone) return;
    el.dataset.trDone = '1';
    var target = parseFloat(el.dataset.trTarget) || 0;
    if (reduce) { el.style.setProperty('--p', target); return; }
    var t0 = null;
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var k = Math.min(1, (ts - t0) / 1600);
      el.style.setProperty('--p', (target * ease(k)).toFixed(1));
      if (k < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function run(group) {
    group.forEach(function (el) {
      if (el.matches('.tr-rep__ring')) animateRing(el);
      else if (el.matches(BAR_SEL)) { el.style.width = el.dataset.trW; }
      else animateCount(el);
    });
  }

  function watch(group, host) {
    if (!hasIO || design) { run(group); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { io.disconnect(); run(group); }
    }, { threshold: 0.35 });
    io.observe(host);
  }

  function initNumbers(scope) {
    var groups = new Map();
    function add(el, host) {
      if (!groups.has(host)) groups.set(host, []);
      groups.get(host).push(el);
    }
    scope.querySelectorAll(COUNT_SEL).forEach(function (el) {
      if (el.dataset.trInit || el.children.length) return;
      el.dataset.trInit = '1';
      el.dataset.trOrig = el.textContent;
      if (el.closest('.tr-rep__ring')) return;
      var p = parseNum(el.textContent);
      if (!p || p.val === 0) return;
      if (el.matches('.tr-ship__bar i')) { /* counted with its bar below */ }
      add(el, el.closest('.tr-marquee') || el);
    });
    scope.querySelectorAll('.tr-rep__ring').forEach(function (el) {
      if (el.dataset.trInit) return;
      el.dataset.trInit = '1';
      el.dataset.trTarget = el.style.getPropertyValue('--p') || '0';
      var span = el.querySelector('span');
      if (span) { span.dataset.trInit = '1'; span.dataset.trOrig = span.textContent; }
      if (!reduce && !design) el.style.setProperty('--p', 0);
      add(el, el);
      if (span) add(span, el);
    });
    scope.querySelectorAll(BAR_SEL).forEach(function (el) {
      if (el.dataset.trW) return;
      el.dataset.trW = el.style.width || '0%';
      if (!reduce && !design) el.style.width = '0%';
      add(el, el.closest('.tr-ship, .tr-rv__bars') || el);
    });
    groups.forEach(function (list, host) {
      // count text starts from zero shape only when it will animate
      watch(list, host);
    });
  }

  function initReveal(scope) {
    if (!hasIO || reduce || design) return;
    root.classList.add('tr-js');
    var targets = [];
    scope.querySelectorAll('.tr-sec > .tr-wrap, .tr-pt .tr-wrap, .tr-footer .tr-wrap, .tr-footer__mark').forEach(function (el) { targets.push(el); });
    scope.querySelectorAll(STAGGER_SEL).forEach(function (el, i) {
      var idx = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.setProperty('--d', Math.min(idx, 7) * 70 + 'ms');
      targets.push(el);
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });
    targets.forEach(function (el) {
      if (el.dataset.trRv) return;
      el.dataset.trRv = '1';
      el.classList.add('tr-reveal');
      io.observe(el);
    });
  }

  function initHeader() {
    var h = document.querySelector('.tr-header');
    if (!h) return;
    function on() { h.classList.toggle('is-stuck', window.scrollY > 6); }
    window.addEventListener('scroll', on, { passive: true });
    on();
  }

  function init(scope) {
    scope = scope || document;
    initNumbers(scope);
    initReveal(scope);
  }

  function boot() { init(document); initHeader(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.trMotionInit = init;
})();
